import { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { Avatar, AvatarFallback, AvatarImage, Badge, ComboboxOptionRenderProps } from "@tellescope/ui";
import { formatInitials, formatName } from "@tellescope/utils";

export interface InboxEmailRecipientItemProps extends ComboboxOptionRenderProps<string> {
  enduser?: TellescopeModelFromName<"endusers">;
  emailAddress?: string;
  relationshipType?: string;
}

export const InboxEmailRecipientItem = ({ enduser, emailAddress, relationshipType }: InboxEmailRecipientItemProps) => {
  if (!enduser) return null;

  const displayName = formatName(enduser);
  const displayEmail = emailAddress || enduser.email;

  return (
    <div className="flex gap-2 items-center justify-between w-full">
      <div className="flex gap-2 items-center min-w-0">
        <Avatar>
          <AvatarImage src={enduser.avatar} />
          <AvatarFallback useStaticBackground={true} id={enduser.id}>
            {formatInitials(enduser)}
          </AvatarFallback>
        </Avatar>
        <div className="flex flex-col min-w-0">
          <p className="font-semibold truncate">{displayName}</p>
          {displayEmail && <p className="text-sm text-muted-foreground truncate">{displayEmail}</p>}
        </div>
      </div>
      {relationshipType && (
        <Badge variant="outline" className="text-xs flex-shrink-0">
          {relationshipType}
        </Badge>
      )}
    </div>
  );
};
